module.exports = __webpack_public_path__ + "static/media/wlzs.56f8857f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/wlzs.jpg
// module id = 1870
// module chunks = 0 1